import React from 'react';

const withSuggestionBox = (ChildComponent) => {
  return ({
    title = '',
    titleType = '',
    cardData = [],
    colorDecider = '',
    onViewAllClick,
    btnText = 'View All',
    ...props
  }) => {
    return (
      <div className={`p-sm-4 p-3 w-100 position-relative ${colorDecider ?? ''}`}>
        <div
          className={`clr_v3_borderGraphics clr_v3_borderGraphics-big py-5  w-100 start-0 translate-middle-y top-50 position-absolute d-flex justify-content-between ${colorDecider == 'bg-primary' ? 'bg-primary' : ''
            }`}
        >
          <div
            className={`h-100 ${colorDecider == 'bg-primary' ? 'bg-white' : 'bg-primary'
              } rounded-4 clr_v3_borderGraphics__line`}
          ></div>
          <div
            className={`h-100 ${colorDecider == 'bg-primary' ? 'bg-white' : 'bg-primary'
              } rounded-4 clr_v3_borderGraphics__line`}
          ></div>
        </div>
        <div className="d-flex justify-content-center align-items-end mb-4 text-start position-relative z-1">
          <h2
            className={`flex-1 me-3 fw-semibold fs-3 ${colorDecider == 'bg-primary' ? 'text-white' : 'text-black'
              }`}
          >
            {titleType && (
              <span className="fs-4 fw-normal d-block">
                {/* Browse */}
                {titleType}
              </span>
            )}
            {/* Other Specialities */}
            {title}
          </h2>

          <a
            href="javascript:void(0)"
            className={`fs-4 fw-semibold ms-auto d-inline-flex gap-2 align-items-center clr_v3_borderGraphics__ttl_link ${colorDecider == 'bg-primary' ? 'text-white' : 'text-primary'
              }`}
            onClick={onViewAllClick}
          >
            {btnText ? (
              <>
                {btnText} <i className="flaticon-chevron fs-16"></i>{' '}
              </>
            ) : (
              ''
            )}
          </a>
        </div>
        <div className="position-relative z-1">
          <ChildComponent {...props} />
        </div>
      </div>
    );
  };
};

export default withSuggestionBox;
